import React, { useState } from 'react';
import { FiMenu } from 'react-icons/fi'; // Import a menu icon from react-icons

const DashSide = () => {
  const [isOpen, setIsOpen] = useState(false); // State to toggle sidebar visibility on small screens

  const toggleSidebar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="flex">
      {/* Hamburger Menu Button for Mobile */}
      <button
        className="text-white bg-gray-900 p-2 focus:outline-none md:hidden"
        onClick={toggleSidebar}
      >
        <FiMenu size={24} /> {/* Menu icon */}
      </button>

      {/* Sidebar - Visible on larger screens (md and up) */}
      <aside
        className={`bg-gray-800 w-64 h-screen fixed md:static top-0 left-0 z-20 transition-transform duration-300 transform md:translate-x-0 ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } md:block`}
      >
        <div className="flex items-center justify-center h-16 bg-gray-900">
          <span className="text-white text-lg font-semibold">Admin Page</span>
        </div>
        <nav className="mt-8">
          <div className="space-y-1">
            <a href="/add" className="text-gray-300 hover:bg-gray-700 hover:text-white block px-4 py-2 text-sm">Add Breakfast</a>
            <a href="/addyoruba" className="text-gray-300 hover:bg-gray-700 hover:text-white block px-4 py-2 text-sm">Add Breakfast Yoruba</a>

            <a href="/sermon" className="text-gray-300 hover:bg-gray-700 hover:text-white block px-4 py-2 text-sm">Add Sermon</a>
            <a href="/holy" className="text-gray-300 hover:bg-gray-700 hover:text-white block px-4 py-2 text-sm">Breakfast With Holyspirit</a>
            <a href="/viewyo" className="text-gray-300 hover:bg-gray-700 hover:text-white block px-4 py-2 text-sm">Breakfast With Holyspirit yoruba</a>
            <a href="/editbook" className="text-gray-300 hover:bg-gray-700 hover:text-white block px-4 py-2 text-sm">Edit Books</a>
            <a href="/addbook" className="text-gray-300 hover:bg-gray-700 hover:text-white block px-4 py-2 text-sm">Add Books</a>
            <a href="/get" className="text-gray-300 hover:bg-gray-700 hover:text-white block px-4 py-2 text-sm">Get Books</a>
          </div>
        </nav>
      </aside>

      {/* Overlay to close the sidebar when clicking outside (for mobile only) */}
      {isOpen && (
        <div
          className="fixed inset-0 bg-black opacity-50 z-10 md:hidden"
          onClick={toggleSidebar}
        ></div>
      )}
    </div>
  );
};

export default DashSide;
